// src/components/Clients/Form/FuecInfo.js

import React, { useEffect, useState } from "react";
import { Form, Input, Select, Typography, Row, Col, InputNumber, Tooltip } from "antd";
import { FileTextOutlined, NumberOutlined, FileProtectOutlined, OrderedListOutlined } from "@ant-design/icons";
import api from "../../../../axiosConfig";
import { filtrarOpcion } from "../../../../utils/filtroSelect";

const { Title, Text } = Typography;
const { Option } = Select;

// Texto corto para el valor seleccionado; el desplegable muestra el objeto completo
const resumen = (texto = "", max = 90) => (texto.length > max ? `${texto.substring(0, max)}...` : texto);

const FuecInfo = () => {
  const form = Form.useFormInstance();
  const objetoSeleccionadoId = Form.useWatch("objeto_contrato_id", form);
  const [objetosContrato, setObjetosContrato] = useState([]);
  const [loadingObjetos, setLoadingObjetos] = useState(false);

  // Cargar objetos de contrato
  useEffect(() => {
    const fetchObjetosContrato = async () => {
      try {
        setLoadingObjetos(true);
        const response = await api.get("/objetos-contrato/list");
        setObjetosContrato(Array.isArray(response.data) ? response.data : response.data.data || []);
      } catch (error) {
        console.error("Error al cargar objetos de contrato:", error);
      } finally {
        setLoadingObjetos(false);
      }
    };

    fetchObjetosContrato();
  }, []);

  return (
    <div style={{ marginBottom: "24px" }}>
      <Title
        level={4}
        style={{
          marginBottom: 16,
          backgroundColor: "#1a5276",
          color: "white",
          padding: "8px",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <FileProtectOutlined style={{ marginRight: "8px" }} />
        Configuracion FUEC
      </Title>

      <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
        Estos campos se utilizan para la generacion del Formato Unico de Extracto del Contrato (FUEC)
      </Text>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label={
              <Tooltip title="Numero unico de contrato asignado para los documentos FUEC">
                <span>
                  <FileTextOutlined style={{ marginRight: 4 }} />
                  No. Contrato
                </span>
              </Tooltip>
            }
            name="numero_contrato_fuec"
            rules={[
              {
                max: 50,
                message: "El numero de contrato no puede exceder 50 caracteres",
              },
            ]}
          >
            <Input placeholder="Ej: 0001" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={
              <Tooltip title="Version del contrato. Se incrementa automaticamente cada 10,000 FUECs generados (V1: 1-9999, V2: 10000-19999, etc.)">
                <span>
                  <NumberOutlined style={{ marginRight: 4 }} />
                  Version
                </span>
              </Tooltip>
            }
            name="fuec_version"
            initialValue={1}
          >
            <InputNumber
              min={1}
              max={99}
              style={{ width: "100%" }}
              placeholder="1"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={
              <Tooltip title="Consecutivo actual del FUEC para este cliente. Se incrementa automaticamente con cada nuevo FUEC generado.">
                <span>
                  <OrderedListOutlined style={{ marginRight: 4 }} />
                  Consecutivo
                </span>
              </Tooltip>
            }
            name="fuec_consecutivo_actual"
            initialValue={0}
          >
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              placeholder="0"
            />
          </Form.Item>
        </Col>
      </Row>

      <Text type="secondary" style={{ fontSize: 11, marginTop: -12, marginBottom: 12, display: "block" }}>
        La Version y Consecutivo se actualizan automaticamente al generar FUECs. Solo modifique manualmente si necesita ajustar el contador.
      </Text>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={
              <Tooltip title="Objeto del contrato predeterminado para este cliente. Puede cambiarse al generar cada FUEC">
                <span>
                  <FileTextOutlined style={{ marginRight: 4 }} />
                  Objeto de Contrato Predeterminado
                </span>
              </Tooltip>
            }
            name="objeto_contrato_id"
          >
            <Select
              placeholder="Seleccione un objeto de contrato predeterminado"
              loading={loadingObjetos}
              allowClear
              showSearch
              filterOption={filtrarOpcion}
              optionLabelProp="label"
              popupMatchSelectWidth={false}
              dropdownStyle={{ maxWidth: "min(720px, 95vw)" }}
            >
              {objetosContrato.map((obj) => (
                <Option key={obj.id} value={obj.id} label={resumen(obj.objeto_contrato || "")}>
                  <Tooltip title={obj.objeto_contrato} placement="right" mouseEnterDelay={0.4}>
                    <div style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.4, padding: "2px 0" }}>
                      {obj.objeto_contrato || ""}
                    </div>
                  </Tooltip>
                </Option>
              ))}
            </Select>
          </Form.Item>
          {objetoSeleccionadoId && (
            <Text type="secondary" style={{ display: "block", marginTop: -16, marginBottom: 16, fontSize: 12, whiteSpace: "normal" }}>
              {objetosContrato.find((obj) => obj.id === objetoSeleccionadoId)?.objeto_contrato}
            </Text>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FuecInfo;
